
<div class="date-picker-container">
  <v-date-picker
    :id="id"
    v-model="content"
    :masks="{ L: 'MMMM D, YYYY' }"
    :min-date="minDate"
    :max-date="maxDate"
    :select-attribute="selectedDate"
    :popover="{ visibility: 'focus' }"
  >
    <template #default="{ inputValue, inputEvents, hidePopover }">
      <span>
        <input
          class="border-1 focus:outline-none focus:border-2 focus:border-grey-clickable rounded-xl min-w-320 text-grey-body"
          :class="[datePickerInput, datePickerValid, customClasses]"
          :placeholder="labelName"
          :value="inputValue"
          v-on="inputEvents"
          @keypress.enter.prevent="emitManualInput(inputValue, $event, hidePopover)"
          @blur="moveLabelDown"
          @focus="moveLabelUp"
        />
        <label :for="id" :class="datePickerLabel">{{ labelName }}</label>
        <div v-if="hasIcon" class="text-field-icon">
          <calendar-outline-icon color="#4B4C52" />
        </div>
      </span>
    </template>
  </v-date-picker>
  <HelperText :id="id" :text="helperText" :status="status" />
</div>
